var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setup_wrap" },
    [
      _vm.active == "first"
        ? _c("div", [_vm._v("\n    无法查看\n  ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.active == "second" ? _c("student") : _vm._e(),
      _vm._v(" "),
      _vm.active == "thrid" ? _c("teacher") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3dbc1b07", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dbc1b07","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/setUp/index.vue
// module id = null
// module chunks = 